import React, { useEffect } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { SlSizeFullscreen } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";


const BackButton = ({ setFullScreen, isFullScreen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    const fromPath = location?.state?.fromPath

    if (fromPath) {
      navigate(fromPath, {state: {pageNumber: location?.state?.pageNumber}});
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <button
        onClick={handleBack}
        className="text-gray-500 hover:text-gray-700 focus:outline-none w-[100px]"
      >
        <span className="flex items-center gap-2 text-sm font-medium">
          <IoMdArrowRoundBack className="w-6 h-6" />
          Go Back
        </span>
      </button>
      <button
        onClick={() => setFullScreen(!isFullScreen)}
        className="hidden md:block"
      >
        <SlSizeFullscreen className="w-6 h-6" />
      </button>
    </div>
  );
};

export default BackButton;
